import './src/styles/_main.scss'

import React from 'react'
import StateProvider from './src/state/global-state'

export const wrapRootElement = ({ element }) => {
    return <StateProvider>{element}</StateProvider>
}

export const onRouteUpdate = ({ location }) => {
    if (typeof window.plausible === 'function') {
        window.plausible('pageview')
    }

    try {
        const pathLang = location.pathname.split('/').filter(Boolean)
        const langPrefix = pathLang[0]
        if (['fr', 'en'].includes(langPrefix)) {
            localStorage.setItem('gatsby-i18next-language', langPrefix)
        } else {
            // default to DE
            localStorage.setItem('gatsby-i18next-language', 'de')
        }
    } catch (error) {
        console.warn('Failed to update language preferences', error)
    }

}
